import React from "react";
import { Form, Select } from "antd";
const { Option } = Select;
export default function SelectInput({
  getFieldDecorator,
  callback = () => {},
  initialValue = undefined,
  labelInValue = false,
  preLoadedData = false,
  label,
  name,
  options = [],
  allowClear,
  disabled = false,
  placeholder = "Seleccione una opción...",
  required = false,
  requiredMessage = "Debe seleccionar un valor.",
}) {
  
  const renderOptions = () => {
    if (preLoadedData) {
      return options?.map((option) => (
        <Option key={option?.key} value={option?.key}>
          {option?.value}
        </Option>
      ));
    } else if (labelInValue) {
      return options?.map((option) => (
        <Option key={option?.key} value={option?.key}>
          {option?.label}
        </Option>
      ));
    } else {
      return options.map((option) => (
        <Option key={option} value={option}>
          {option}
        </Option>
      ));
    }
  };

  return (
    <Form.Item label={label}>
      {getFieldDecorator(name, {
        initialValue: initialValue,
        rules: [
          {
            required: required,
            message: requiredMessage,
          },
        ],
      })(
        <Select
          onChange={(option) => callback(option, name)}
          allowClear={allowClear}
          disabled={disabled}
          labelInValue={labelInValue}
          placeholder={placeholder}
        >
          {renderOptions()}
        </Select>
      )}
    </Form.Item>
  );
}
